<template>
  <v-navigation-drawer
      v-model="showRightMenu"
      right
      fixed
      touchless
      clipped
      class="navigation-menu"
    >
      <v-list class="pa-1">

        <v-list-tile class="pt-1 no-hover" tag="div" @click="goHomeAndClearSearch">
          <!-- v-list-tile-avatar>
            <img src="https://randomuser.me/api/portraits/men/85.jpg">
          </v-list-tile-avatar -->

          <v-list-tile-content>
            <v-list-tile-title style="color: white;">
              <v-icon color="white" class="pr-2">fa-home</v-icon>
              {{ capitalize($t('go_home')) }}
            </v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn icon @click.stop="showRightMenu = false" color="white">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-layout wrap>
          <v-flex xs12 mt-2 mx-3>
            <flags className="flags-menu" />
          </v-flex>
          <v-flex xs12 mt-3 mx-3
            v-if="favorites.length > 0"
            style="line-height: 18px; color: white;"
            @click="showFavoritesFromRightMenu()"
          >
            <i
              class="fa fa-heart"
              style="font-size: 18px; padding-right: 5px;"
            ></i> {{ $t('saved_favorites') }}
          </v-flex>
        </v-layout>

      </v-list>

      <v-list class="pt-0" dense>
        <template
          v-for="(key, menuIndex) in Object.keys(menu)"
        >
          <div
            v-if="menu[key]['menuName_' + lang] && menu[key].showOnMobile"
            :key="menuIndex"
            @click="showPageId(menu[key])"
            class="first-level"
          >
            {{ menu[key]['menuName_' + lang] }}
          </div>

          <div
            v-for="(submenuItem, menuIndex2) in menu[key].children
              .filter(name => !!name[['menuName_' + lang]] && name.showOnMobile)"
            :key="menuIndex + '_' + menuIndex2 + '_lm'"
            @click="showPageId(submenuItem)"
            class="mobile-second-level"
          >
             - {{ submenuItem[['menuName_' + lang]] }}
          </div>
        </template>
      </v-list>
      <v-list>
        <v-layout>
          <v-flex xs12 mt-2 mx-3 mb-3>
            <main-share color="white" />
          </v-flex>
        </v-layout>
      </v-list>

    </v-navigation-drawer>
</template>

<script>
import MainShare from './_MainShare'
import Flags from './Flags'
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'RightMenu',

  components: {
    Flags,
    MainShare
  },

  data () {
    return {
      showMenuId: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    menu () {
      let menu = {}
      // level 1
      this.menuResponse.forEach(item => {
        if (!item.parent) {
          menu[item._id] = item
          menu[item._id].children = []
        }
      })
      // level 2
      this.menuResponse.forEach(item => {
        if (item.parent && item.parent._id && menu[item.parent._id]) {
          menu[item.parent._id].children.push(item)
        }
      })
      return menu
    }
  },

  methods: {
    ...sharedMethods,

    showFavoritesFromRightMenu () {
      this.goToFavorites()
      this.showRightMenu = false
    },

    showMenu (id) {
      this.showMenuId = id
    },

    hideMenu () {
      this.showMenuId = null
    }
  }
}
</script>

<style>
.navigation-menu {
  background: #219bc8 !important;
  color: white;
}
.first-level {
  cursor: pointer;
  font-weight: bold;
  color: white;
  padding: 10px 15px 2px 15px;
}
.mobile-second-level {
  cursor: pointer;
  padding: 0 10px 0 25px;
  color: white;
  height: 32px;
  line-height: 32px;
}
.mobile-second-level:hover {
  background: #ffcb01;
}
.bedroom-button {
  border-radius: 4px;
  margin: 3px 5px;
  padding: 5px;
  text-align: center;
  border: 1px solid grey;
  color: white;
  width: 30px;
  height: 30px;
  line-height: 20px;
  background: #ffcb01;
  cursor: pointer;
  float: left;
}
.mobile-with-buttons {
  padding: 0 10px 0 25px;
  height: 40px;
  line-height: 40px;
  color: white;
}
.no-hover:hover, .no-hover div:hover {
  background: none !important;
}
</style>
